import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import "../../../Styles/movieDetail.scss";

const columns = [
  { id: "movieTitle", label: "Movie Title", minWidth: 170 },
  { id: "duration", label: "Duration", maxWidth: 200, align: "center" },
];

export default function MovieDetailTable({ setPageNumber, pageNumber, onSearchChange }) {
  const gridData = useSelector(
    (state) => state?.watchedHoursGrid?.getWatchedHoursGridReq
  );
  const [searchText, setSearchText] = React.useState("");
  const [page, setPage] = React.useState(pageNumber - 1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  React.useEffect(() => {
    if (pageNumber - 1 !== page) {
      setPage(pageNumber - 1);
    }
  }, [pageNumber, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setPageNumber(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const formatDuration = (hoursWatched) => {
    const totalSeconds = Math.round(hoursWatched * 3600);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (totalSeconds === 0) return "0";
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes.toString().padStart(2, '0')}m`);
    parts.push(`${seconds.toString().padStart(2, '0')}s`);

    return parts.join(" ");
  };

  const rows = gridData?.map((item) => ({
    movieTitle: item.title,
    duration: formatDuration(item.hoursWatched),
    totalCount: item.totalCount,
  })) ?? [];

  const handleSearch = () => {
    onSearchChange(searchText);
  };

  const handleClear = () => {
    setSearchText("");
    onSearchChange("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const isEmpty = rows?.length === 0;

  return (
    <>
        <TextField
          label="Search by Movie Title"
          variant="outlined"
          style={{
            width: "250px",
            marginTop: "20px",
            marginBottom: "0px",
            backgroundColor: "white",
          }}
          margin="normal"
          value={searchText}
          onChange={(e) => {
            const newText = e.target.value;
            setSearchText(newText);
            onSearchChange(newText); 
          }}
          onKeyDown={handleKeyDown}
          InputProps={{
            classes: { input: "custom-input" },
            endAdornment: (
              <InputAdornment position="end">
                {searchText && (
                  <IconButton onClick={handleClear}>
                    <ClearIcon />
                  </IconButton>
                )}
                <IconButton onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: {
              lineHeight: "14px",
            },
          }}
        />


      <div className="content-Grid-Container">
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ height: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#949CB0",
                        color: "white",
                        zIndex:0
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isEmpty ? (
                  <TableRow>
                    <TableCell
                      colSpan={columns?.length}
                      align="center"
                      style={{ color: "black" }}
                    >
                      No results found
                    </TableCell>
                  </TableRow>
                ) : (
                  rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {columns?.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={rows[0]?.totalCount ?? 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </>
  );
}
